const en: Record<string, string> = {
  'guitarSong.list.add': 'Add song',
  'guitarSong.list.loadError': 'Could not load the songbook.',
  'guitarSong.list.searchPlaceholder': 'Search title, author, lyrics…',
  'guitarSong.list.noResults': 'No songs match your search or filters.',
  'guitarSong.list.clearFilters': 'Clear filters',
  'guitarSong.card.tempo': '{{bpm}} BPM · {{beats}} beats/bar',
  'guitarSong.card.capo': 'Capo {{fret}}',
  'guitarSong.card.chordCount': '{{count}} chords',
  'guitarSong.card.difficultChordCount': '{{count}} difficult',
  'guitarSong.state.draft': 'Draft',
  'guitarSong.state.completed': 'Completed',
  'guitarSong.difficulty.label': 'Difficulty',
  'guitarSong.difficulty.level0': 'Very easy',
  'guitarSong.difficulty.level1': 'Easy',
  'guitarSong.difficulty.level2': 'Moderate',
  'guitarSong.difficulty.level3': 'Intermediate',
  'guitarSong.difficulty.level4': 'Hard',
  'guitarSong.difficulty.level5': 'Very hard',
  'guitarSong.mastery.label': 'My mastery',
  'guitarSong.mastery.level0': 'Unknown',
  'guitarSong.mastery.level1': 'Just started',
  'guitarSong.mastery.level2': 'Learning',
  'guitarSong.mastery.level3': 'Getting there',
  'guitarSong.mastery.level4': 'Confident',
  'guitarSong.mastery.level5': 'Mastered',
  'guitarSong.form.title': 'Title',
  'guitarSong.form.author': 'Author',
  'guitarSong.form.authorPlaceholder': 'Choose an author',
  'guitarSong.form.addNewAuthor': '+ Add a new author…',
  'guitarSong.form.newAuthorPlaceholder': 'New author name',
  'guitarSong.form.copyFromSong': 'Copy from a song',
  'guitarSong.form.copyFromSongHelp': 'Start with everything from another song — chords, lyrics, videos, labels and layout — you can still change the title and author above.',
  'guitarSong.form.copyFromSongPlaceholder': 'No copy',
  'guitarSong.form.template': 'Layout template',
  'guitarSong.form.templateHelp': 'Start from another song\'s layout instead of the default one.',
  'guitarSong.form.templatePlaceholder': 'Default layout',
  'guitarSong.form.blankLayout': 'Start from a blank page',
  'guitarSong.form.blankLayoutHelp': 'No rows are added for you — build the page yourself, one row/column/element at a time.',
  'guitarSong.form.contentType': 'Content',
  'guitarSong.form.contentTypeLayout': 'Free-form layout',
  'guitarSong.form.contentTypePdf': 'Uploaded PDF',
  'guitarSong.form.contentTypeHelp': 'Choose how this song\'s content works — this cannot be changed later.',
  'guitarSong.form.pdfFile': 'PDF file',
  'guitarSong.form.pdfFileHelp': 'Upload a PDF sheet instead of building a layout.',
  'guitarSong.form.pdfFileButton': 'Choose a PDF file',
  'guitarSong.form.pdfFileUploadError': 'Could not upload the file. Please try again.',
  'guitarSong.form.labels': 'Labels',
  'guitarSong.form.addTitle': 'Add a song',
  'guitarSong.form.diagramStyle': 'Chord diagram style',
  'guitarSong.form.diagramStyleFull': 'Full (labeled intervals)',
  'guitarSong.form.diagramStyleSimple': 'Simple (dots only)',
  'guitarSong.form.diagramStyleFullShort': 'Full',
  'guitarSong.form.diagramStyleSimpleShort': 'Simple',
  'guitarSong.form.diagramSize': 'Chord diagram size',
  'guitarSong.form.diagramSizeXxs': 'XXS',
  'guitarSong.form.diagramSizeXs': 'XS',
  'guitarSong.form.diagramSizeS': 'S',
  'guitarSong.form.diagramSizeM': 'M',
  'guitarSong.form.diagramSizeL': 'L',
  'guitarSong.form.diagramSizeXl': 'XL',
  'guitarSong.form.diagramSizeXxl': 'XXL',
  'guitarSong.form.lyricsLineSpacing': 'Line spacing (px)',
  'guitarSong.form.lyricsTextSize': 'Lyrics text size (px)',
  'guitarSong.form.lyricsChordSize': 'Chord badge size (px)',
  'guitarSong.detail.loadError': 'Could not load the song.',
  'guitarSong.detail.statBpm': 'BPM',
  'guitarSong.detail.statBeatsPerBar': 'Beats/bar',
  'guitarSong.detail.statCapo': 'Capo',
  'guitarSong.detail.chords': 'Chords',
  'guitarSong.detail.chordGrid': 'Chord Grid',
  'guitarSong.detail.addChord': 'Add chord',
  'guitarSong.detail.removeChord': 'Remove from song',
  'guitarSong.detail.removeChordConfirm': 'Remove {{name}} from this song? It will stay in the shared chord inventory.',
  'guitarSong.detail.moveUp': 'Move up',
  'guitarSong.detail.moveDown': 'Move down',
  'guitarSong.detail.comment': 'Comment',
  'guitarSong.detail.commentPlaceholder': 'e.g. play softly, muted strum…',
  'guitarSong.detail.archive': 'Archive song',
  'guitarSong.detail.archiveTitle': 'Archive song',
  'guitarSong.detail.archiveMessage': 'Archive "{{title}}"? It will no longer appear in the songbook.',
  'guitarSong.detail.markCompleted': 'Mark as completed',
  'guitarSong.detail.backToDraft': 'Back to draft',
  'guitarSong.detail.backToList': 'Back to songbook',
  'guitarSong.picker.title': 'Add a chord to this song',
  'guitarSong.picker.add': 'Add to song',
  'guitarSong.sections.blockOption': 'Lyrics & Chords #{{index}}',
  'guitarSong.sections.setupConfirm': 'Start this block',
  'guitarSong.sections.linkToExisting': 'Link to existing block',
  'guitarSong.sections.linkToExistingNone': 'None — new content',
  'guitarSong.sections.linkedContentNote': 'Mirrors the linked block',
  'guitarSong.sections.linkedTo': 'Linked to',
  'guitarSong.sections.lyricsPlaceholder': 'Type the lyrics for this block…',
  'guitarSong.sections.attachChords': 'Attach chords',
  'guitarSong.sections.hideAttachChords': 'Done attaching chords',
  'guitarSong.sections.noChord': 'No chord',
  'guitarSong.sections.emptySlotLabel': '(gap)',
  'guitarSong.sections.positionBefore': 'Before',
  'guitarSong.sections.positionStart': 'Start',
  'guitarSong.sections.positionMiddle': 'Middle',
  'guitarSong.sections.positionEnd': 'End',
  'guitarSong.sections.positionAfter': 'After',
  'guitarSong.sections.previousPosition': 'Previous position',
  'guitarSong.sections.nextPosition': 'Next position',
  'guitarSong.sections.previousWord': 'Previous word',
  'guitarSong.sections.nextWord': 'Next word',
  'guitarSong.chordGrid.editCell': 'Edit cell',
  'guitarSong.chordGrid.chordSize': 'Chord text size',
  'guitarSong.chordGrid.borderTop': 'Top',
  'guitarSong.chordGrid.borderRight': 'Right',
  'guitarSong.chordGrid.borderBottom': 'Bottom',
  'guitarSong.chordGrid.borderLeft': 'Left',
  'guitarSong.chordGrid.moveItemLeft': 'Move left',
  'guitarSong.chordGrid.moveItemRight': 'Move right',
  'guitarSong.chordGrid.removeItem': 'Remove',
  'guitarSong.chordGrid.addTextPlaceholder': 'Add text (e.g. x4)',
  'guitarSong.chordGrid.addText': 'Add text',
  'guitarSong.chordGrid.needsChordsBlock': 'Add a Chords block to the page first to add chords here.',
  'guitarSong.chordGrid.addRowBefore': 'Insert row before',
  'guitarSong.chordGrid.addRowAfter': 'Insert row after',
  'guitarSong.chordGrid.removeRow': 'Remove row',
  'guitarSong.chordGrid.addColumnBefore': 'Insert column before',
  'guitarSong.chordGrid.addColumnAfter': 'Insert column after',
  'guitarSong.chordGrid.removeColumn': 'Remove column',
  'guitarSong.videos.title': 'Videos',
  'guitarSong.videos.add': 'Add video',
  'guitarSong.videos.remove': 'Remove video',
  'guitarSong.videos.titlePlaceholder': 'Title (optional)',
  'guitarSong.videos.urlLabel': 'Video URL',
  'guitarSong.learningTools.title': 'Learning tools',
  'guitarSong.labels.newLabelPlaceholder': 'New label name',
  'guitarSong.labels.createLabel': 'Create label',
  'guitarSong.labels.manageLabels': 'Manage labels',
  'guitarSong.labels.moveLeft': 'Move label earlier',
  'guitarSong.labels.moveRight': 'Move label later',
  'guitarSong.layout.presentationMode': 'Presentation view',
  'guitarSong.layout.backToSong': 'Back to editing',
  'guitarSong.layout.downloadPdf': 'Download PDF',
  'guitarSong.pdf.openInNewTab': 'Open in a new tab',
  'guitarSong.pdf.replaceButton': 'Replace PDF',
  'guitarSong.pdf.replaceHelp': 'Uploading a new file replaces the current one.',
  'guitarSong.layout.pageSettingsLabel': 'Page settings',
  'guitarSong.layout.pageSizeLabel': 'Page size',
  'guitarSong.layout.showStructureOutlines': 'Show row/column/block outlines',
  'guitarSong.layout.hideStructureOutlines': 'Hide row/column/block outlines',
  'guitarSong.layout.pageSizeA4': 'A4 (matches PDF)',
  'guitarSong.layout.pageSizeA4Caption': 'A4 ({{width}} mm)',
  'guitarSong.layout.pageSizeLetter': 'US Letter',
  'guitarSong.layout.pageSizeLetterCaption': 'Letter ({{width}} mm)',
  'guitarSong.layout.pageSizeFull': 'Full width',
  'guitarSong.layout.pageSizeCustom': 'Custom',
  'guitarSong.layout.pageSizeCustomWidthLabel': 'Width (mm)',
  'guitarSong.layout.openMarginsMenu': 'Page margins',
  'guitarSong.layout.marginTop': 'Top (mm)',
  'guitarSong.layout.marginRight': 'Right (mm)',
  'guitarSong.layout.marginBottom': 'Bottom (mm)',
  'guitarSong.layout.marginLeft': 'Left (mm)',
  'guitarSong.layout.footerSpacing': 'Footer spacing (mm)',
  'guitarSong.layout.rowMenu': 'Row options',
  'guitarSong.layout.columnMenu': 'Column options',
  'guitarSong.layout.blockMenu': 'Block options',
  'guitarSong.layout.editBlock': 'Edit',
  'guitarSong.layout.copyBlock': 'Copy',
  'guitarSong.layout.addBlockAfter': 'Add block after',
  'guitarSong.layout.addEmptyBlockOption': 'Empty block',
  'guitarSong.layout.pasteBlock': 'Paste',
  'guitarSong.layout.previewClipboard': 'See what is copied',
  'guitarSong.layout.pasteOtherSong': 'Copied from another song',
  'guitarSong.layout.clipboardUnavailable': 'This copied content is no longer available.',
  'guitarSong.layout.blockContentTab': 'Content',
  'guitarSong.layout.blockTitleTab': 'Titles',
  'guitarSong.layout.blockSharedTab': 'Shared',
  'guitarSong.layout.blockPresentationTab': 'Presentation',
  'guitarSong.layout.emptyBlock': 'Empty {{type}} — click Edit to fill it in',
  'guitarSong.layout.addRow': 'Add row',
  'guitarSong.layout.insertRowHere': 'Insert row here',
  'guitarSong.layout.pageBreakBefore': 'Start a new page before this row',
  'guitarSong.layout.removeRow': 'Remove row',
  'guitarSong.layout.removeRowConfirm': 'Remove this row and everything in it? This cannot be undone.',
  'guitarSong.layout.removeColumn': 'Remove column',
  'guitarSong.layout.columnPresentation': 'Presentation',
  'guitarSong.layout.addToThisColumn': 'Add to this column',
  'guitarSong.layout.addNewColumn': 'Add a new column',
  'guitarSong.layout.addElementPlaceholder': 'Element',
  'guitarSong.layout.addElementConfirm': 'Add',
  'guitarSong.layout.addCustomBlock': '+ Custom text',
  'guitarSong.layout.removeBlock': 'Remove block',
  'guitarSong.layout.removeBlockConfirm': 'Remove this block? This cannot be undone.',
  'guitarSong.layout.removeBlockTitle': 'Remove title',
  'guitarSong.layout.blockTitlePlaceholder': 'Block title',
  'guitarSong.layout.customBlockTitle': 'Block title',
  'guitarSong.layout.customBlockContentSize': 'Text size',
  'guitarSong.layout.customBlockWidth': 'Width (1-{{max}})',
  'guitarSong.layout.blockZoom': 'Zoom % (30-200)',
  'guitarSong.layout.titleHeadingLevel': 'Title size',
  'guitarSong.layout.blockShowCard': 'Show as card',
  'guitarSong.layout.customBlocksTitle': 'Custom blocks',
  'guitarSong.layout.widthNarrower': 'Narrower',
  'guitarSong.layout.widthWider': 'Wider',
  'guitarSong.layout.noRoomForNewColumn': 'No room left in this row — narrow a column first',
  'guitarSong.layout.moveColumnLeft': 'Move column left',
  'guitarSong.layout.moveColumnRight': 'Move column right',
  'guitarSong.layout.moveBlockLeft': 'Move element left',
  'guitarSong.layout.moveBlockRight': 'Move element right',
  'guitarSong.layout.addEmptyColumn': 'Empty column (for spacing)',
  'guitarSong.layout.pasteToNewColumn': 'Paste into a new column',
  'guitarSong.layout.addEmptyRow': 'Empty row (for spacing)',
  'guitarSong.layout.alignLeft': 'Left',
  'guitarSong.layout.alignCenter': 'Center',
  'guitarSong.layout.alignRight': 'Right',
  'guitarSong.layout.paddingTop': 'Padding top (mm)',
  'guitarSong.layout.paddingRight': 'Padding right (mm)',
  'guitarSong.layout.paddingBottom': 'Padding bottom (mm)',
  'guitarSong.layout.paddingLeft': 'Padding left (mm)',
  'guitarSong.layout.paddingTopShort': 'Top',
  'guitarSong.layout.paddingRightShort': 'Right',
  'guitarSong.layout.paddingBottomShort': 'Bottom',
  'guitarSong.layout.paddingLeftShort': 'Left',
  'guitarSong.layout.columnMarginsTitle': 'Margins',
  'guitarSong.layout.blockMarginsTitle': 'Margins',
  'guitarSong.layout.separatorLeft': 'Left column separator',
  'guitarSong.layout.separatorRight': 'Right column separator',
  'guitarSong.layout.block.title': 'Title',
  'guitarSong.layout.block.author': 'Author',
  'guitarSong.layout.block.tempo': 'Tempo (BPM)',
  'guitarSong.layout.block.time_signature': 'Time signature',
  'guitarSong.layout.block.capo': 'Capo',
  'guitarSong.layout.block.description': 'Description',
  'guitarSong.layout.block.chords': 'Chord progression',
  'guitarSong.layout.block.sections': 'Sections & lyrics',
  'guitarSong.layout.block.labels': 'Labels',
  'guitarSong.layout.block.chord_grid': 'Chord grid',
  'guitarSong.layout.block.custom': 'Custom text',
};

export default en;
